import LocalstorageLastUrl from './LocalstorageLastUrl';

export default LocalstorageLastUrl;
